/** DD-3726: the lab's electronic invoicing state, as the backend's labEInvoicing returns it. */
export type LabEInvoicing = {
    enabled: boolean;
    /** Epoch milliseconds; null until enabled. */
    enabledAt: number | null;
    migrated: boolean;
    /** E_INVOICING_* keys of what the lab must fix; empty when nothing. */
    requirements: string[];
    canEnable: boolean;
    /** ISO codes of the countries e-invoicing is open in (Sweden only for now). */
    supportedCountries: string[];
};

/** DD-3726: whether one customer accepts e-invoices from the lab (Crediflow's answer). */
export enum CustomerEInvoicingStatus {
    READY = 'READY',
    INVITE_NEEDED = 'INVITE_NEEDED',
    DECLINED = 'DECLINED',
    NOT_FOUND = 'NOT_FOUND',
    SEVERAL_MATCHES = 'SEVERAL_MATCHES',
}

export type EInvoiceInvite = {
    id: number;
    type: number;
    email: string;
    status: string;
    /** Epoch milliseconds. */
    sentAt: number;
};

export type CustomerEInvoicing = {
    status: CustomerEInvoicingStatus;
    receiverPartyId?: number | null;
    organizationNumber?: string | null;
    countryCode?: string | null;
    gln?: string | null;
    /** Epoch milliseconds of the last Crediflow check. */
    checkedAt?: number | null;
    invite?: EInvoiceInvite | null;
};
